export default __webpack_public_path__ + "static/media/brainhealth-logo-brain.5156f59b.svg";